import ProgressBarNew from "components/ProgressBarNew";
import React, { useState } from "react";
import add_icon from "./images/add_icon.png";
import minus_icon from "./images/minus_icon.png";
import "./index.scss";
const zjcolors = ["#03BF8A", "#3192FF", "#FA9237", "#09B9B6", "#A185EB"];

function TreeNode({ data }) {
  const [isExpanded, setIsExpanded] = useState(true);
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  console.log(data);
  return (
    <div className="tree_card_flex_box">
      <div
        onClick={toggleExpand}
        className="tree_card_flex"
        style={{ cursor: "pointer" }}
      >
        {isExpanded ? (
          <img src={minus_icon} className="isExpanded_img" alt="" />
        ) : (
          <img className="isExpanded_img" src={add_icon} alt="" />
        )}
        {data.nodeLevel == 2 && (
          <span className="tree_card_name">{data.name}</span>
        )}
        {data.nodeLevel != 2 && (
          <div className="tree_card_progress_bar">
            <ProgressBarNew
              emissionValue={Number(data?.summaryValueInt?.toFixed(5))}
              unit={data.unit}
              title={data.name}
              color={
                Number(data.proportion) < 0 ? "rgb(255, 86, 96)" : zjcolors[0]
              }
              percent={data.proportionAbsolute?.replace("%", "")}
              proportion={data.proportion}
            />
          </div>
        )}
      </div>
      {isExpanded && data.nodeLevel == 2 && (
        <div className="tree_card_nodeLevel1_bar_style">
          <div className="tree_card_nodeLevel1_box">
            <div className="tree_card_nodeLevel1">
              <p>碳排放</p>
              <span>{Number(data?.summaryValueInt?.toFixed(5))}</span>
            </div>
            <div className="tree_card_nodeLevel1">
              <p>占比</p>
              <span>{data?.proportion}%</span>
            </div>
          </div>
          <div className="mt-8">
            <ProgressBarNew
              emissionValue={Number(data?.summaryValueInt?.toFixed(5))}
              unit={data.unit}
              title={data.name}
              color={
                Number(data.proportion) < 0 ? "rgb(255, 86, 96)" : zjcolors[0]
              }
              percent={data.proportionAbsolute?.replace("%", "")}
              proportion={data.proportion}
            />
          </div>
        </div>
      )}

      {isExpanded && data.children && data.children.length > 0 && (
        <div
          style={{ marginLeft: data.nodeLevel == 2 ? 0 : ".75rem" }}
          className="tree-children-box"
        >
          {data?.children?.map((child, index) => {
            console.log(child);
            return (
              <div key={index}>
                {child?.children?.length > 0 ? (
                  <TreeNode data={child} />
                ) : (
                  <div className="" style={{ paddingTop: "0.55rem" }}>
                    <ProgressBarNew
                      key={index}
                      emissionValue={Number(child?.summaryValueInt?.toFixed(5))}
                      unit={child.unit}
                      title={child.name}
                      color={
                        Number(data.proportion) < 0
                          ? "rgb(255, 86, 96)"
                          : zjcolors[0]
                      }
                      percent={child.proportionAbsolute?.replace("%", "")}
                      proportion={child.proportion}
                    />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

function TreeCard({ data }) {
  return (
    <div className="product_details_tree">
      {data?.children?.map((node, index) => {
        return (
          <div key={index}>
            <TreeNode data={node} />
          </div>
        );
      })}
    </div>
  );
}

export default TreeCard;
